import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'va-status-banner',
  templateUrl: './va-status-banner.component.html',
  styleUrls: ['./va-status-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VaStatusBannerComponent {
  @Input() statusTitle: string;
  @Input() statusText: string;
  @Input() type: string;
  @Input() border = true;
  @Input() actionTitle: string;
  @Input() actionCallback: () => void;
}
